import React, { useCallback, useEffect } from "react";
import { useRouter } from "next/router";
import Head from "next/head";

import CommunityThreadPage from "@/containers/CommunityThreadPage";

import { useAppDispatch } from "@/hooks";

import * as actions from "@/redux/CommunityReducer";
import * as dashboardActions from "@/redux/DashboardReducer";
import { wrapper } from "@/redux/Store";

const CommunityThread = ({ postData }) => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const postId = router?.query?.postId?.[0];

  const getCommunityThreadByID = useCallback(
    () => dispatch(actions.getCommunityThreadByID({ id: postId })),
    [dispatch, postId]
  );

  useEffect(() => {
    getCommunityThreadByID();
  }, [getCommunityThreadByID]);

  const {
    text: _title = "",
    share_meta_image_link:
      thumbnail = "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/shyft.jpg",
    topic,
    share_meta: shareDetails,
  } = postData || {};
  const { title: _topic } = topic || {};

  const title = `${_title} | ${_topic}`;
  const description = `${_topic}: Read this post to know about ${_title}`;

  const { url: shareUrl } = shareDetails || {};

  let canonicalURL = "";
  if (shareUrl) {
    let [protocol, origin] = shareUrl.split("//") || [];
    origin = origin?.replace("www.", "");
    origin = origin?.split("?")[0];
    canonicalURL = `https://www.${origin}/`;
  }

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:site_name" content="Shyft" />
        <meta property="og:image" content={thumbnail} />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href={canonicalURL} key="canonical" />
      </Head>
      <CommunityThreadPage />
    </>
  );
};

export default CommunityThread;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ query }) => {
      await store.dispatch(
        dashboardActions.getRibbonData({ pathname: "community-thread" })
      );

      const postId = query?.postId?.[0];
      const res = await store.dispatch(
        actions.getCommunityThreadByID({ id: postId })
      );
      const postData = res?.payload?.data || {};
      return { props: { postData } };
    }
);
